import { holatVar } from "@/shared/charts/palette";
import { Sparkline as ChartSparkline } from "@/shared/charts/Sparkline";

export interface SparklineProps {
	/**
	 * Foiz qiymatlari, kun tartibida.
	 *
	 * ⚠️⚠️ **`null` — MA'LUMOTSIZ kun, `0` EMAS.** Trend marshruti
	 * kogortasi bo'sh kunni (dam olish) UMUMAN qator bermaydi
	 * (`AttendanceTrendSchema` izohi), ya'ni chaqiruvchi bo'shliqni
	 * `null` bilan to'ldiradi. `0` bilan to'ldirilsa sparkline har
	 * yakshanba 0% ga qulardi.
	 */
	points: (number | null)[];
	width?: number;
	height?: number;
	/** ⚠️ MAJBURIY — diagramma ekran o'quvchisiga matn bilan yetkaziladi. */
	ariaLabel: string;
}

/**
 * Boshqaruv paneli sparkline'i — `shared/charts/Sparkline` moslamasi.
 *
 * ⚠️⚠️ **Y masshtabi DOIM 0–100, avtomatik EMAS** — shuning uchun
 * `min`/`max` ANIQ uzatiladi. Umumiy primitiv ularsiz shkalani
 * ma'lumotdan oladi va 92%↔93% tebranish «qulash» bo'lib ko'rinardi.
 *
 * ⚠️ Oxirgi nuqta — TUGALLANMAGAN kun, marker OCHIQ (ichi oq).
 * Marker ichi `#ffffff` saqlanadi — `Sparkline.test.tsx` uni pinlagan;
 * chiziq rangi esa `holatVar("kelgan")` (dark rejimda moslashadi).
 */
export function Sparkline({ points, width = 300, height = 52, ariaLabel }: SparklineProps) {
	return (
		<ChartSparkline
			points={points}
			color={holatVar("kelgan")}
			width={width}
			height={height}
			min={0}
			max={100}
			area
			markerFill="#ffffff"
			ariaLabel={ariaLabel}
		/>
	);
}
